var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCad = function SvgCad(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5513_108040",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 16,
    height: 12,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5513_108040)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2H12.5V14H4V2Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16447 6.20127L7.98652 5L8 12H7.65742L7.86761 10.2677C7.86761 10.2677 5.56179 10.6912 5.75241 10.4776C5.94304 10.264 6.05283 9.87204 6.05283 9.87204L4 8.47393C4 8.47393 4.32382 8.46978 4.58726 8.30984C4.8507 8.1499 4.32382 7.20134 4.32382 7.20134L5.36027 7.35527L5.75241 6.92023L6.53439 7.7557H6.8859L6.53439 5.842L7.16447 6.20127ZM8 12V5L8.83553 6.20127L9.46561 5.842L9.1141 7.7557H9.46561L10.2476 6.92023L10.6397 7.35527L11.6762 7.20134C11.6762 7.20134 11.1493 8.1499 11.4127 8.30984C11.6762 8.46978 12 8.47393 12 8.47393L9.94717 9.87204C9.94717 9.87204 10.057 10.264 10.2476 10.4776C10.4382 10.6912 8.13239 10.2677 8.13239 10.2677L8.34258 12H8Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2H16V14H12V2Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2H4V14H0V2Z",
    fill: "#E31D1C"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "CAD.56811aba9f3ccd2d4a348c26a04e3cde.svg";